var map = {
	"./ai.png": 1125,
	"./api.png": 2543,
	"./aws.png": 2184,
	"./azure.png": 5754,
	"./claude.png": 8737,
	"./cpp.png": 6716,
	"./cursor.png": 5513,
	"./django.png": 2478,
	"./express.png": 5395,
	"./figma.png": 7219,
	"./git.png": 319,
	"./html.png": 2800,
	"./javascript.png": 8102,
	"./kotlin.png": 3224,
	"./mcp.png": 8512,
	"./n8n.png": 7799,
	"./next.png": 3628,
	"./node.png": 4923,
	"./openai.png": 9421,
	"./ps.png": 8756,
	"./pydantic.png": 8681,
	"./python.png": 1025,
	"./react.png": 2450,
	"./sass.png": 2445,
	"./tailwind.png": 2991,
	"./tf.png": 133,
	"./typescript.png": 6078,
	"./xd.png": 4003
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 748;